import { Component, inject, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  private router = inject(Router);
  protected readonly isDashboardRoute = signal(false);
  private titleService = inject(Title);

  constructor() {
    this.titleService.setTitle(environment.appName);
    // Listen to route changes to determine if we're on dashboard
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isDashboardRoute.set(event.url.includes('/dashboard'));
      });
  }
}
